import React from 'react'

const SelectPrimary = ({
  id,
  options,
  register,
  validation,
  defaultOption = '',
  className = '',
  ...props
}) => {
  return (
    <select
      id={id}
      {...register(id, validation)}
      className={`w-full py-2 px-0 border-0 border-b border-primary focus:outline-none focus:ring-0 focus:border-b-1 focus:border-primary ${className}`}
      {...props}
    >
      {defaultOption && <option value="">{defaultOption}</option>}
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default SelectPrimary
